import { render, staticRenderFns } from "./SearchWeightCreate.vue?vue&type=template&id=ce1adba2&"
import script from "./SearchWeightCreate.vue?vue&type=script&lang=js&"
export * from "./SearchWeightCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports